import React, { useState } from "react";
import { openVideoList } from "../../helpers/service";

// Style
import {
  BestPlayerWrap,
  BestPlayersTable,
  BestPlayerContent,
  BestPlayerName,
  BestPlayerValue,
  BestPlayerWrapper,
} from "../../style/TournamentsPage";

import { getPlayerParamMarkers } from "../../helpers";

// Images
import star from "../../images/ic_start.svg";
import emptyState from "../../images/contactLogo.svg";

// Components
import Empty from "../../components/empty/index";
import { NotificationList } from "../notification/NotificationList";
import { useNotification } from "../notification/useNotification";

// Language
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import {
  TabContent,
  TabListWrapper,
  TabsWrapper,
  TabTitle,
  TopList,
} from "../../style/Favorites";
import { useLexicon } from "../../hooks/useLexicon";
import { useParameterLexicon } from "../../hooks/useParameterLexicon";

const BestPlayers = ({ table, info }) => {
  const l = useLexicon();
  const { getPlayerParameterLexiconId } = useParameterLexicon();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [expandedIndices, setExpandedIndices] = useState([]);
  const { id } = useParams();

  const toggleShowLeads = (index) => {
    setExpandedIndices((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const excludeKeywords = [
    "Fouls",
    "Cards",
    "Losses",
    "Mistakes",
    "Offsides",
    "GK",
    "Effective Saves",
    "Progressive Carries",
    "Clean Sheets",
    "Goals conceded",
    "Saved shots",
  ];

  const filteredTable = table?.filter(
    (item) =>
      !excludeKeywords.some((keyword) =>
        Object.values(item).some(
          (value) => typeof value === "string" && value.includes(keyword)
        )
      )
  );

  // const getSpecialSortedParamsGk = (arr) => {
  //   try {
  //     const sortedArr = arr?.sort((a, b) => a.parameter_id - b.parameter_id);
  //     const goalsConcededIdx = sortedArr?.findIndex(
  //       (item) => item.parameter_id === 173
  //     );
  //     const cleenSheetsIdx = sortedArr?.findIndex((item) => item.parameter_id === "-173");
  //     if (cleenSheetsIdx + 1 >= arr.length) {
  //       var k = cleenSheetsIdx + 1 - arr.length + 1;
  //       while (k--) {
  //         sortedArr.push(undefined);
  //       }
  //     }
  //     sortedArr.splice(goalsConcededIdx + 1, 0, sortedArr.splice(cleenSheetsIdx, 1)[0]);
  //     return sortedArr;
  //   } catch (e) {
  //     console.log("error special sort", e);
  //     return arr?.sort((a, b) => a.parameter_id - b.parameter_id);
  //   }
  // };

  const gkTable = table?.filter((item) =>
    Object.values(item).some(
      (value) => (
        typeof value === "string" &&
        value !== ("GK Interceptions") &&
        value !== ("Ariel Duels (GK)") &&
        (
          value === "Saved shots" ||
          value.includes("GK") ||
          value.includes("Clean Sheets") ||
          value.includes("Goals conceded")
        )
      )
    )
  ).sort((a, b) => a.parameter_id - b.parameter_id);

  const { notifications, addNotification, removeNotification } =
    useNotification();

  const getParameterDisplayName = (parameterInput) => {
    const fallbackName =
      typeof parameterInput === "string"
        ? parameterInput
        : parameterInput?.parameter_name || parameterInput?.name || "";
    if (!fallbackName) return '';
    const lexiconId = getPlayerParameterLexiconId(parameterInput);
    if (lexiconId) {
      return l(lexiconId) || fallbackName;
    }
    return fallbackName;
  };

  const handleClickPlayerParam = async (item, leader) => {
    const { parameter_id: param_id } = item;
    const { player: { id: player_id, display_name }, value: count } = leader;
    try {
      const controller = new AbortController();
      addNotification(`Fetching clips. Please don't close or refresh the page till the download is completed.`, "info", controller);
      document.body.classList.add("loading-cursor");
      const data = await getPlayerParamMarkers(
        player_id,
        param_id,
        '',
        controller,
        1,
        id,
      );
      if (data?.results?.length > 0) {
        const markers = data.results.map((item) => item.id).join(",");
        const displayName = getParameterDisplayName(item);
        openVideoList(markers, `${displayName} - ${display_name}`);
      } else {
        addNotification(
          `There are 0 clips in the response from the server.`,
          "warning"
        );
      }
    } catch (e) {
      console.log("error get param markers", e);
      if (e.type === "canceled") {
        addNotification(
          `The request to receive ${count} clips of the player has been canceled.`,
          "warning"
        );
        return;
      }
      addNotification(`Error in receiving ${count} player clips.`, "error");
    } finally {
      document.body.classList.remove("loading-cursor");
    }
  };

  const isCanClickPlayerStat = (leader, item) => {
    return (
      item.leaders?.count === 0 ||
      item.parameter_name.includes("%") ||
      item.parameter_name.includes("Mins Played") ||
      item.parameter_name.includes("Clean Sheets")
    );
  };

  return (
    <>
      <TabsWrapper>
        <TopList>
          <TabListWrapper>
            <TabTitle>{l(5)}</TabTitle>
            <TabTitle>{l(1011)}</TabTitle>
          </TabListWrapper>
        </TopList>
        <TabContent>
          {" "}
          <BestPlayerWrap>
            {filteredTable?.map((item, index) => {
              const displayName = getParameterDisplayName(item);
              return (
              <BestPlayersTable key={index}>
                <h2>{displayName}</h2>
                {item?.leaders.length > 0 ? (
                  <>
                    {item?.leaders?.slice(0, 5)?.map((leader, idx) => (
                      <BestPlayerContent key={idx}>
                        <BestPlayerWrapper>
                          <BestPlayerName
                            href={`/tournaments/player/${leader.player.id}`}
                          >
                            {/* <img src={star} alt={star} /> */}
                            <img
                              src={leader.player.photo ?? emptyState}
                              alt={leader.player.photo ?? emptyState}
                              className="profileImage"
                            />
                            <h5>{leader.player.display_name}</h5>
                          </BestPlayerName>
                          <BestPlayerValue>
                            <h5
                              style={
                                isCanClickPlayerStat(leader, item)
                                  ? { cursor: "not-allowed" }
                                  : { cursor: "pointer" }
                              }
                              onClick={() =>
                                !isCanClickPlayerStat(leader, item) &&
                                handleClickPlayerParam(item, leader)
                              }
                              onContextMenu={e => {
                                e.preventDefault()
                                !isCanClickPlayerStat(leader, item) &&
                                  handleClickPlayerParam(item, leader)
                              }}
                            >
                              {leader.value}
                            </h5>
                          </BestPlayerValue>
                        </BestPlayerWrapper>
                      </BestPlayerContent>
                    ))}
                    {item?.leaders?.length > 5 && (
                      <>
                        {expandedIndices.includes(index)
                          ? item?.leaders?.slice(5)?.map((leader, idx) => (
                            <BestPlayerContent key={idx}>
                              <BestPlayerWrapper>
                                <BestPlayerName
                                  href={`/tournaments/player/${leader.player.id}`}
                                >
                                  {/* <img src={star} alt={star} /> */}
                                  <img
                                    src={leader.player.photo ?? emptyState}
                                    alt={leader.player.photo ?? emptyState}
                                    className="profileImage"
                                  />
                                  <h5>{leader.player.display_name}</h5>
                                </BestPlayerName>
                                <BestPlayerValue>
                                  <h5
                                    style={
                                      isCanClickPlayerStat(leader, item)
                                        ? { cursor: "not-allowed" }
                                        : { cursor: "pointer" }
                                    }
                                    onClick={() =>
                                      !isCanClickPlayerStat(leader, item) &&
                                      handleClickPlayerParam(item, leader)
                                    }
                                    onContextMenu={e => {
                                      e.preventDefault()
                                      !isCanClickPlayerStat(leader, item) &&
                                        handleClickPlayerParam(item, leader)
                                    }}
                                  >
                                    {leader.value}
                                  </h5>
                                </BestPlayerValue>
                              </BestPlayerWrapper>
                            </BestPlayerContent>
                          ))
                          : null}
                        <button onClick={() => toggleShowLeads(index)}>
                          {expandedIndices.includes(index)
                            ? l(1013)
                            : l(1012)}
                        </button>
                      </>
                    )}
                  </>
                ) : (
                  <h2>{l(464)}</h2>
                )}
              </BestPlayersTable>
              );
            })}
          </BestPlayerWrap>
        </TabContent>

        <TabContent>
          {" "}
          <BestPlayerWrap>
            {gkTable?.map((item, index) => {
              const displayName = getParameterDisplayName(item);
              return (
              <BestPlayersTable key={item.parameter_id}>
                <h2>{displayName}</h2>
                {item?.leaders.length > 0 ? (
                  <>
                    {item?.leaders?.slice(0, 5)?.map((leader, idx) => (
                      <BestPlayerContent key={idx}>
                        <BestPlayerWrapper>
                          <BestPlayerName
                            href={`/tournaments/player/${leader.player.id}`}
                          >
                            {/* <img src={star} alt={star} /> */}
                            <img
                              src={leader.player.photo ?? emptyState}
                              alt={leader.player.photo ?? emptyState}
                              className="profileImage"
                            />
                            <h5>{leader.player.display_name}</h5>
                          </BestPlayerName>
                          <BestPlayerValue>
                            <h5
                              style={
                                isCanClickPlayerStat(leader, item)
                                  ? { cursor: "not-allowed" }
                                  : { cursor: "pointer" }
                              }
                              onClick={() =>
                                !isCanClickPlayerStat(leader, item) &&
                                handleClickPlayerParam(item, leader)
                              }
                              onContextMenu={e => {
                                e.preventDefault()
                                !isCanClickPlayerStat(leader, item) &&
                                handleClickPlayerParam(item, leader)
                              }}
                            >
                              {leader.value}
                            </h5>
                          </BestPlayerValue>
                        </BestPlayerWrapper>
                      </BestPlayerContent>
                    ))}
                    {item?.leaders?.length > 5 && (
                      <>
                        {expandedIndices.includes(index)
                          ? item?.leaders?.slice(5)?.map((leader, idx) => (
                            <BestPlayerContent key={idx}>
                              <BestPlayerWrapper>
                                <BestPlayerName
                                  href={`/tournaments/player/${leader.player.id}`}
                                >
                                  {/* <img src={star} alt={star} /> */}
                                  <img
                                    src={leader.player.photo ?? emptyState}
                                    alt={leader.player.photo ?? emptyState}
                                    className="profileImage"
                                  />
                                  <h5>{leader.player.display_name}</h5>
                                </BestPlayerName>
                                <BestPlayerValue>
                                  <h5
                                    style={
                                      isCanClickPlayerStat(leader, item)
                                        ? { cursor: "not-allowed" }
                                        : { cursor: "pointer" }
                                    }
                                    onClick={() =>
                                      !isCanClickPlayerStat(leader, item) &&
                                      handleClickPlayerParam(item, leader)
                                    }
                                    onContextMenu={e => {
                                      e.preventDefault()
                                      !isCanClickPlayerStat(leader, item) &&
                                      handleClickPlayerParam(item, leader)
                                    }}
                                  >
                                    {leader.value}
                                  </h5>
                                </BestPlayerValue>
                              </BestPlayerWrapper>
                            </BestPlayerContent>
                          ))
                          : null}
                        <button onClick={() => toggleShowLeads(index)}>
                          {expandedIndices.includes(index)
                            ? l(1013)
                            : l(1012)}
                        </button>
                      </>
                    )}
                  </>
                ) : (
                  <h2>{l(464)}</h2>
                )}
              </BestPlayersTable>
              );
            })}
          </BestPlayerWrap>
        </TabContent>
      </TabsWrapper>

      {/* display notifications */}
      <NotificationList
        notifications={notifications}
        onClose={removeNotification}
      />
    </>
  );
};

export default BestPlayers;
